import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

import { buildUploaderUrl, uploaderDisplayPath } from "@/lib/uploader-url";

/**
 * Read-only preview — the whole card is one button (like every other
 * settings card) that opens the "done" step, which already shows this
 * same QR code plus a copy/open link. No separate `<a>` here: nesting
 * an anchor inside the card's wrapping `<button>` would be invalid HTML.
 */
export function SharePreviewCard({ slug }: { slug: string }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3 bg-card p-4">
      <div className="shrink-0 rounded-md border bg-white p-1.5">
        <QRCodeSVG value={buildUploaderUrl(slug)} size={56} level="M" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-medium">{t("setup.preview.shareTitle")}</p>
        <p className="truncate font-mono text-sm text-muted-foreground">
          {uploaderDisplayPath(slug)}
        </p>
      </div>
    </div>
  );
}
